import { toast } from 'sonner';

// Shared admin API wrapper: on 401 the session is dead — log out cleanly and go to login
export const adminFetch = async (url, options = {}) => {
  const res = await fetch(url, options);
  if (res.status === 401) {
    localStorage.removeItem('adminToken');
    toast.error('Session expired — please log in again');
    setTimeout(() => { window.location.href = '/admin'; }, 1500);
  }
  return res;
};
